import { processJsonString } from '@/h5/utils/stringProcess'
import { getBridgeWindow, setBridgeWindow } from '@/packages/plugins/appUAConfig'

const getJavascriptBridge = () => getBridgeWindow()

// 创建桥接函数
const setupWebViewJavascriptBridge = (callback) => {
  console.log('UnityBridge: 开始创建桥接函数', window)
  if (window.Unity) {
    callback(window.Unity)
    return true
  } else {
    console.error('UnityBridge: 创建桥接函数失败')
    return false
  }
}

// 过滤相同事件
// const messageMap = new Map()
// const checkMessage = (message) => {
//   if (messageMap.has(message)) {
//     const time = messageMap.get(message)
//     if (time && new Date().getTime() - time > 2000) {
//       // 2s后自行销毁相同事件
//       console.error('checkMessage: timeout')
//       messageMap.delete(message)
//       return true
//     }
//     return false
//   }
//   messageMap.set(message, new Date().getTime())
//   return true
// }

const checkCallbackFunction = (message, callbackName, callbackData) => {
  const name = message.split('&')[0]
  const paramStr = message.split('&')[1]
  // console.log('checkCallbackFunction', callbackName, getJavascriptBridge().callbackQueue.length)
  if (name === callbackName && name === 'h5Req') {
    // 接口调用,存在异步回调情况,特殊处理
    try {
      const params = JSON.parse(paramStr)
      const callbackParams = processJsonString(callbackData)
      // console.log('---callbackName----1', params)
      // console.log('---callbackData----2', callbackParams)
      if (!callbackParams) {
        console.error('UnityBridge: h5Req回调参数解析失败', callbackData)
        return false
      }
      if (Number(params.reqId) === Number(callbackParams.reqId)) {
        // messageMap.delete(message)
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('UnityBridge: h5Req提交参数解析失败', error)
      return false
    }
  } else if (name === callbackName) {
    // messageMap.delete(message)
    return true
  }
  return false
}

const handleCallbackFunction = (callbackName, callbackData) => {
  const javascriptBridge = getJavascriptBridge()
  const callbacks = javascriptBridge.callbackQueue
  let callbackIndex = -1
  for (let i = 0; i < callbacks.length; i++) {
    const callback = callbacks[i]
    const message = callback.message
    if (checkCallbackFunction(message, callbackName, callbackData)) {
      callback.callback(callbackName, callbackData)
      callbackIndex = i
      break
    }
  }
  if (callbackIndex !== -1) {
    javascriptBridge.callbackQueue.splice(callbackIndex, 1)
  }
}

/**
 * 初始化与 Unity 的连接
 * 如果桥接对象不存在或 Callback 函数未定义，
 * 创建一个新的桥接对象，
 * 其中 Callback 函数用于接收来自 Unity 的回调，
 * 这样可以确保 Unity 可以调用前端的回调函数。
 * @param callback
 */
const initWebViewJavascriptBridge = (callback) => {
  const javascriptBridge = getJavascriptBridge()
  if (!javascriptBridge || !javascriptBridge.Callback) {
    console.log('UnityBridge: 初始化Unity连接')
    setBridgeWindow({
      callbackQueue: [],
      Callback: (callbackName, callbackData) => {
        handleCallbackFunction(callbackName, callbackData)
      },
      RegisterUnityMethod: (methodName, methodFunction) => {
        // 这里注册你的方法，以便 Unity 调用
        // methodName 是方法名，methodFunction 是方法的实际函数
        getJavascriptBridge()[methodName] = methodFunction
      }
    })
  } else {
    javascriptBridge.Callback = (callbackName, callbackData) => {
      handleCallbackFunction(callbackName, callbackData)
    }
  }

  if (callback) {
    callback()
  }
}

// 导出桥接对象
const UnityBridge = {
  // 注册前端方法供 Unity 使用
  registerHandler(methodName, methodFunction) {
    initWebViewJavascriptBridge(() => {
      if (getJavascriptBridge()) {
        getJavascriptBridge().RegisterUnityMethod(methodName, methodFunction)
      } else {
        console.error('UnityBridge: Unity 桥接未初始化')
      }
    })
  },

  /**
   * JS 向 Unity 发送消息
   * @param message 格式: 'getLogInfo&xx&cccc'
   * @param callback
   */
  callHandler(message, callback) {
    console.log('UnityBridge: 发送message', message)
    // 初始化桥接函数
    // if (!checkMessage(message)) {
    //   return
    // }
    // const tag = new Date().getTime()
    // console.log('---tag', tag)
    const result = setupWebViewJavascriptBridge((bridge) => {
      console.log('UnityBridge: 发送message', message)

      // 初始化桥接对象并确保 callbackQueue 存在
      initWebViewJavascriptBridge(() => {
        // 存储回调函数到队列中
        getJavascriptBridge().callbackQueue.push({
          callback: (callbackName, data) => {
            // console.log('---tag----', tag)
            callback(callbackName, data)
          },
          message: message
        })
        // 与 Unity 确认的 JS 发送通知方法
        bridge.call(message)
      })
    })

    if (!result) {
      callback(false)
    }
  }
}

export default UnityBridge
